import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { setupAxios } from './services/api'

// Import Firefox-specific fixes
import './assets/css/firefox-fixes.css'

// Setup axios interceptors
setupAxios()

const app = createApp(App)

app.use(router)
app.use(store)
app.mount('#app')

